import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { DateUtils, UrlUtils } from '@atlassian/mpac-utils';
import { lastDayOfMonth, lastDayOfYear, startOfMonth, startOfYear } from 'date-fns';
import invariant from 'invariant';
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import queryString from 'query-string';
import { partnerReportsRoute } from "../../../constants/Routes";
import { defaultFilters } from "./defaultFilters";
export const getNewReportPathname = (partnerId, currentReportName, shouldAppendUrl, selectedOptionValue) => UrlUtils.resolveUrlFromTemplateAndParameters({
  template: UrlUtils.transformRoutePathToUriTemplate({
    routePath: partnerReportsRoute.path
  }),
  parameters: {
    partnerId,
    reportName: shouldAppendUrl ? selectedOptionValue : currentReportName
  }
});
export const getDateRangeForAPeriodFilter = period => {
  const today = new Date();
  const lastMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const lastYearDate = new Date(today.getFullYear() - 1, 1, 1);
  let startDate = DateUtils.ISOFormatHyphenatedDate(new Date());
  let endDate = DateUtils.ISOFormatHyphenatedDate(new Date());

  switch (period) {
    case 'past30Days':
      startDate = DateUtils.ISOFormatHyphenatedDate(DateUtils.subtractDateByDays(new Date(), 30));
      break;

    case 'past90Days':
      startDate = DateUtils.ISOFormatHyphenatedDate(DateUtils.subtractDateByDays(new Date(), 90));
      break;

    case 'thisMonth':
      startDate = DateUtils.ISOFormatHyphenatedDate(startOfMonth(new Date()));
      break;

    case 'lastMonth':
      startDate = DateUtils.ISOFormatHyphenatedDate(startOfMonth(lastMonthDate));
      endDate = DateUtils.ISOFormatHyphenatedDate(lastDayOfMonth(lastMonthDate));
      break;

    case 'thisYear':
      startDate = DateUtils.ISOFormatHyphenatedDate(startOfYear(lastMonthDate));
      break;

    case 'lastYear':
      startDate = DateUtils.ISOFormatHyphenatedDate(startOfYear(lastYearDate));
      endDate = DateUtils.ISOFormatHyphenatedDate(lastDayOfYear(lastYearDate));
      break;
  }

  return {
    startDate,
    endDate
  };
};
export const getNewSearch = (currentParams, selectedOptionQueryParam, selectedOptionValue) => {
  if (!selectedOptionQueryParam) {
    invariant(selectedOptionValue, 'selected option value is required');
    return "?".concat(queryString.stringify(defaultFilters[selectedOptionValue]));
  }

  let newParams = {
    [selectedOptionQueryParam]: selectedOptionValue
  };

  if (selectedOptionQueryParam === 'period') {
    delete currentParams.startDate;
    delete currentParams.endDate;

    if (selectedOptionValue === 'custom') {
      newParams.startDate = DateUtils.ISOFormatHyphenatedDate(DateUtils.subtractDateByDays(new Date(), 30));
      newParams.endDate = DateUtils.ISOFormatHyphenatedDate(new Date());
    }
  } // Assign startDate with endDate if selected startDate > endDate
  else if (selectedOptionQueryParam === 'endDate' || selectedOptionQueryParam === 'startDate') {
    const startDate = newParams.startDate || currentParams.startDate;
    const endDate = newParams.endDate || currentParams.endDate; // $FlowFixMe: We can plainly see this is a string!

    if (new Date(startDate) > new Date(endDate)) {
      newParams = {
        startDate: selectedOptionValue,
        endDate: selectedOptionValue
      };
    }
  }

  return "?".concat(queryString.stringify(pickBy(_objectSpread(_objectSpread({}, currentParams), newParams), identity)));
};